module.exports = __webpack_public_path__ + "img/head-portrait.157bb4b1.png";